import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
import { avoidAuthToken } from "@adapters/constants";
class HeaderRepository {
    constructor(http) {
        this.http = http;
    }
    async getMenuData() {
        const response = await this.http.request({
            method: "GET",
            url: "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/edel/menu",
        });
        //   if(response) {
        //     return response.boards.map((board: IBoardParams) => new BoardDTO(board))
        //   }
        if (response) {
            return response;
        }
    }
    async getMarketData() {
        const url = new URL(urlConfig.market.status);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: {},
            avoidAuthToken,
        });
    }
}
export default HeaderRepository;
